var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarrot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5165 2.61079C13.0004 3.13366 12.8325 3.86683 13.0029 4.54592L12.9436 4.60607C14.5056 4.69083 16.0759 5.31855 17.3357 6.52186C18.5956 7.72536 19.2796 9.2513 19.4116 10.785L19.4714 10.7243C20.1663 10.8718 20.9062 10.6851 21.4222 10.1623C22.2341 9.33977 22.1843 7.99679 21.3111 7.16267C20.9857 6.85182 20.5918 6.65551 20.1837 6.57411C20.5401 5.78761 20.364 4.81148 19.6744 4.15273C18.9847 3.49394 17.9876 3.34959 17.1989 3.72326C17.1042 3.32428 16.8931 2.94269 16.5677 2.6318C15.6944 1.79767 14.3284 1.78827 13.5165 2.61079Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.28175 19.0297C1.23894 20.8034 3.29822 22.7705 5.06977 21.6929L15.4667 15.3687C18.2783 13.6584 18.705 9.80302 16.3334 7.5376C13.9617 5.27218 10.0569 5.80519 8.40179 8.62025L7.33935 10.4273L8.61555 11.4317C8.93956 11.6867 8.9921 12.1518 8.73288 12.4706C8.47367 12.7893 8.00087 12.841 7.67685 12.586L6.57844 11.7215L5.71529 13.1897L6.61202 13.8954C6.93604 14.1504 6.98857 14.6155 6.72936 14.9342C6.47014 15.253 5.99734 15.3047 5.67332 15.0497L4.95439 14.4839L2.28175 19.0297Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrot);
export default __webpack_public_path__ + "static/media/carrot.de6c9711b2ad75bef818bb1d407f7705.svg";
export { ForwardRef as ReactComponent };